import type { ReactNode } from 'react'
import { X } from 'lucide-react'
import { Button } from '../ui/Button'
import listStyles from '@/styles/pages/governance/GovernanceListing.module.scss'

type Props = {
  title: ReactNode
  onClose: () => void
  children: ReactNode
  footer?: ReactNode
  className?: string
}

export function GovernanceInlineFormPanel({ title, onClose, children, footer, className }: Props) {
  return (
    <section className={`${listStyles.inlineFormPanel} ${className ?? ''}`.trim()} aria-labelledby="governance-inline-form-title">
      <div className={listStyles.inlineFormHeader}>
        <h3 id="governance-inline-form-title" className={listStyles.inlineFormTitle}>
          {title}
        </h3>
        <Button
          type="button"
          size="small"
          color="outline"
          iconOnly
          icon={<X className={listStyles.badgeIcon} aria-hidden />}
          onClick={onClose}
          aria-label="Close"
        />
      </div>
      <div className={listStyles.inlineFormBody}>{children}</div>
      {footer ? <div className={listStyles.inlineFormActions}>{footer}</div> : null}
    </section>
  )
}

export default GovernanceInlineFormPanel
